import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'selectOptions',
    standalone: false
})
export class SelectOptionsPipe implements PipeTransform {
  transform(value: [{label: string, value: string}]): any {
    if (!value) {
      return value
    }

    return value.map(option => ({
        viewValue: option.label,
        value: option.value
      }));
  }
}
